import { every, get, noop, reduce, some } from 'lodash-es';
import { user, UserState } from '../../user';

type Rule = () => Promise<boolean>;

export interface RuleSet {
  rule: Rule;
  onFailure?: () => void | Promise<any>;
}

export function checkRuleSetInSequence(ruleSet: RuleSet[]) {
  // @ts-ignore
  return reduce(
    ruleSet,
    (promise, next: RuleSet) => {
      const { rule, onFailure } = next;
      // @ts-ignore
      return promise.then(rule).then((value) => {
        if (value === false) {
          if (typeof onFailure === 'function') {
            const ret = onFailure();
            if (typeof get(ret, 'then') === 'function') {
              return ret;
            } else {
              // never return
              return new Promise(noop);
            }
          } else {
            return value;
          }
        }
      });
    },
    Promise.resolve(),
  );
}

/***
 * 反转一个条件
 * @param rule
 * @constructor
 */
export function Not(rule: Rule) {
  return function() {
    return rule().then((result) => !result);
  };
}

/***
 * 满足部分条件
 * @param rules
 * @constructor
 */
export function Some(...rules: Rule[]) {
  return function() {
    return Promise.all(rules.map((rule) => rule())).then(some);
  };
}

export function Every(...rules: Rule[]) {
  return function() {
    return Promise.all(rules.map((rule) => rule())).then(every);
  };
}

/***
 * 检查用户是否关注
 */
export function isSubscribe() {
  return user.getUserInfo().then((userInfo) => {
    return userInfo.subscribe === '1';
  });
}

/***
 * 返回一个用于判断用户状态的Rule
 * @param states
 */
export function userHasState(states: any[]) {
  return function() {
    return user.getUserInfo().then<any>((userInfo) => {
      return states.indexOf(userInfo.userstate) >= 0;
    });
  };
}

/***
 * 检查用户是否开户或绑户
 */
export const hasAccount = userHasState([
  UserState.HAS_BUNDLE,
  UserState.HAS_ACCOUNT,
]);
